import React, { useState } from "react"
import contact from "../../assets/images/contact/undraw_businessman_97x4.svg"
import { useForm } from "react-hook-form"
import { navigate } from "gatsby"
import { Alert, Col, Row } from "react-bootstrap"
import { Turnstile } from "@marsidev/react-turnstile"

/**
 * Simple hook utilizing reac-thook useForm and provides various other values.
 */
export const useContactForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: "onBlur"
  })

  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(false)
  const [turnstileToken, setTurnstileToken] = useState(null)

  const handleServerResponse = async (ok, form) => {
    if (ok) {
      await navigate(form.getAttribute("action"))
    } else {
      setSubmitted(false)
      setError(true)
    }
  }

  const onSubmit = (data, e) => {
    e.preventDefault()
    setSubmitted(true)
    setError(false)

    const form = e.target
    const formData = {
      "form-name": e.target.getAttribute("name"),
      "cf-turnstile-response": turnstileToken,
      ...data
    }

    fetch("https://functions.logentis.net/contact_form", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    }).then(res => handleServerResponse(res.ok, form))
      .catch(() => handleServerResponse(false, form))
      .finally(() => setSubmitted(false))
  }
  const isErrors = (errors && Object.keys(errors).length !== 0) || !turnstileToken

  return { register, errors, isErrors, submitted, error, handleSubmit, onSubmit, setTurnstileToken }
}

const ContactForm = () => {
  const { error, errors, handleSubmit, isErrors, onSubmit, register, submitted, setTurnstileToken } = useContactForm()

  return (
    <section className="contact-area pb-100 pt-100">
      <div className="container">
        <div className="section-title">

        </div>

        <Row>
          <Col lg={4} md={12}>
            <div className="contact-image">
              <img src={contact} alt="contact" />
            </div>

            <div className="contact-info-box mt-5">
              <div className="back-icon">
                <i className="bx bx-phone-call" />
              </div>
              <div className="icon">
                <i className="bx bx-phone-call" />
              </div>
              <h2>Oder ohne Formular</h2>
              <p>Telefon: <a href="tel:+495415805870">+49 (0)541 - 5805870</a></p>
              <p>E-mail: <a href="mailto:info@logentis.de">info@logentis.de</a></p>
            </div>
          </Col>

          <Col lg={8} md={12}>
            <div className="contact-form">
              <form name={"contactForm"}
                    onSubmit={handleSubmit(onSubmit)}
                    method={"POST"}
                    encType={"application/x-www-form-urlencoded"}
                    action={"/success"}
              >
                <input type="hidden" name="form-name" value="contactForm" />
                <Row>
                  <h1 className={"h2"}>Interesse geweckt? Kontaktieren Sie uns!</h1>
                </Row>
                {error &&
                  <Row>
                    <Col lg={10}>
                      <Alert variant={"warning"}>
                        Fehler beim Versenden. Bitte nochmal versuchen.
                      </Alert>
                    </Col>
                  </Row>
                }
                <Row>
                  <Col lg={12} md={6}>
                    <div
                      className={`form-group ${(isErrors && errors.NAME) ? "has-error" : ""}`}>
                      <input
                        type="text"
                        {...register("NAME", {
                          required: "Name notwendig"
                        })}
                        style={{ width: "80%" }}
                        className="form-control m-2"
                        placeholder="Ihr Name*" />
                      <div className={"ml-3"}>{isErrors && errors.NAME &&
                        <span className="error">{errors.NAME.message}</span>}</div>
                    </div>
                  </Col>

                  <Col lg={12} md={6}>
                    <div
                      className={`form-group ${(isErrors && errors.EMAIL) ? "has-error" : ""}`}>
                      <input
                        type="email"
                        {...register("EMAIL", {
                          required: "Email notwendig"
                        })}
                        style={{ width: "80%" }}
                        className="form-control m-2"
                        placeholder="Ihre Emailadresse*" />
                      <div className={"ml-3"}>{isErrors && errors.EMAIL &&
                        <span className="error">{errors.EMAIL.message}</span>}</div>
                    </div>
                  </Col>

                  <Col lg={12} md={12}>
                    <div
                      className={`form-group ${(isErrors && errors.PHONE) ? "has-error" : ""}`}>
                      <input
                        type="text"
                        {...register("PHONE", {
                          required: "Telefonnummer notwendig"
                        })}
                        name={"PHONE"}
                        style={{ width: "80%" }}
                        className="form-control m-2"
                        placeholder="Ihre Telefonnummer" />
                      <div className={"ml-3"}>{isErrors && errors.PHONE &&
                        <span className="error">{errors.PHONE.message}</span>}</div>
                    </div>
                  </Col>

                  <Col lg={12} md={12}>
                    <div
                      className={`form-group ${(isErrors && errors.MESSAGE) ? "has-error" : ""}`}>
                      <textarea
                        {...register("MESSAGE", {
                          required: "Nachricht notwendig"
                        })}
                        className="form-control m-2"
                        style={{ width: "60%" }}
                        cols="30"
                        rows="6"
                        placeholder="Ihre Nachricht...*" />
                      <div className={"ml-3"}>{isErrors && errors.MESSAGE &&
                        <span className="error">{errors.MESSAGE.message}</span>}</div>
                    </div>
                  </Col>

                  <Col lg={12} md={12}>
                    <button type="submit" className="default-btn m-2" disabled={submitted || isErrors}>
                      <i className="flaticon-tick" />
                      {submitted && "Wird abgeschickt...."}
                      {!submitted && "Abschicken"}
                    </button>
                  </Col>
                  <Col lg={12} md={12}>
                    <Turnstile className={'m-2'} siteKey="0x4AAAAAACKKyTBXWAgCLjrX" options={{ theme: "light" }} onSuccess={setTurnstileToken} />
                  </Col>
                  <Col lg={12} md={12} className="mt-5">
                    <p className={"text-black-50"}><small>Ihre Emailadresse wird nur für den Kontakt genutzt. Notwendige
                      Felder markiert mit *</small></p>
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default ContactForm
